<template lang="pug">
modal#collect-recipient-modal(
  :no-footer='true'
  :title='$t("modal.selectQualifiedSignatureTypeModal.title")'
  ref='modal'
  size='sm'
)
  p(v-html='$t("modal.selectQualifiedSignatureTypeModal.message1")')
  p {{ $t('modal.selectQualifiedSignatureTypeModal.message2') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/safe-screen.svg')
  .text-center.mt-5.margin-buttons
    .d-flex.justify-content-center.gap-3(
      :class='isMobileScreen ? "flex-column" : "flex-nowrap"'
    )
      button.btn.btn-primary-outline.text-nowrap(
        @click='selectType("birdId")'
        style='border-width: 1px'
        type='button'
      )
        icon(name='bird-id' type='brands')
        span.text {{ $t('modal.selectQualifiedSignatureTypeModal.birdId') }}
      button.btn.btn-primary.text-nowrap(
        :hidden='isMobile'
        @click='selectType("plugin")'
        style='border-width: 1px'
        type='button'
      )
        span.text {{ $t('modal.selectQualifiedSignatureTypeModal.plugin') }}
  a.text-link.d-block.text-center(
    @click.prevent='openBirdIdTrialEmissionModal'
    href='#'
    v-if='hasBirdIdTrialEmissionLink'
  ) 
    | {{ $t('modal.selectQualifiedSignatureTypeModal.trial') }}
</template>
<script>
import Icon from '@/ui/atoms/Icon.vue';
import Modal from '@/ui/molecules/Modal.vue';
import config from '@/config';

export default {
  name: 'SelectQualifiedSignatureTypeModal',
  components: {
    Icon,
    Modal,
  },
  data() {
    return {
      birdIdTrialEmissionUrl: '',
    };
  },
  computed: {
    isMobile() {
      return this.$root.isMobile;
    },
    isMobileScreen() {
      return this.$root.isMobileScreen;
    },
    hasBirdIdTrialEmissionLink() {
      if (config.birdIdTrialEmission) {
        return true;
      }
      return false;
    },
  },
  methods: {
    selectType(type) {
      this.$emit('update-type', type);
      this.$refs.modal.close();
    },
    openBirdIdTrialEmissionModal() {
      this.$emit('open-birdid-trial-emission-modal');
      this.$refs.modal.close();
    },
  },
};
</script>

<style lang="stylus" scoped>
p
  font-size: 16px
  line-height: 24px
img
  margin: 32px
  width: 184.371px
  height: 155px
  flex-shrink: 0
button
  padding: 8px
  display: flex
  flex-direction: row
  align-items: center !important
  justify-content: center
  text-align: center
.margin-buttons
  margin-bottom: 32px !important
.text-link
  text-align: center
  font-size: 14px
  font-weight: 400
  line-height: normal
  font-style: normal
  color: #0080A3
</style>
